export default ({ width = 14, height = 18, color = 'currentColor' }) => (
  <svg className='topic-view_sticky-flag' width={width} height={height}
    fill={color}
    viewBox='0 0 14 18' xmlns='http://www.w3.org/2000/svg'>
    <path d='M14 0H0V18L7 15L14 18V0Z' />
  </svg>
)
